export { ContactInformationPurposeType } from './generated/ContactInformationPurposeType.js';